import React from 'react';
import { Block, ImageBlockContent } from '../types';
import { ControlPanelSwitchButton } from './control-panel/switch';
import { ImageLightNeueIcon } from 'src/monet/icons';
import { useBlockActions } from '../helpers/actions/use-block-actions.hook';

interface Props {
  block: Block;
  disabled?: boolean;
}

export const ToggleBackground = ({ block }: Props) => {
  const blockContent = block.content as ImageBlockContent;
  const { onBlockParamsChange } = useBlockActions(block);

  return (
    <ControlPanelSwitchButton
      label='Remove background'
      icon={<ImageLightNeueIcon className='shrink-0' />}
      checked={blockContent.removeBackground || false}
      onChange={(value) => {
        onBlockParamsChange(block.id, {
          removeBackground: value,
        });
      }}
    />
  );
};
